export default __webpack_public_path__ + "static/media/grappe-171x365.a51b82c5.svg";